export const labelledById = (id: string) => `modal-${id}-title`
